/**
 * Smoothly scrolls the window so `element` lands `offset` pixels below the
 * top of the viewport (offset accounts for fixed/sticky navigation bars).
 */
export const smoothScrollToElement = (element: HTMLElement, offset: number) => {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - offset,
    behavior: 'smooth',
  })
}
